/**
 * ToastContainer Component
 * 
 * Renders toast notifications with optional action buttons.
 * Validates: Requirements 23.1, 23.2, 23.5
 */

import * as React from 'react';
import {
  ToastProvider as RadixToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastAction,
} from '@/components/ui/Toast';
import { useToast } from '@/hooks';

export function ToastContainer(): React.ReactElement {
  const { toasts, dismiss } = useToast();

  return (
    <RadixToastProvider>
      {toasts.map((toast) => (
        <Toast key={toast.id} variant={toast.variant} open onOpenChange={() => dismiss(toast.id)}>
          <div className="grid gap-1">
            <ToastTitle>{toast.title}</ToastTitle>
            {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
          </div>
          {toast.action && (
            <ToastAction
              altText={toast.action.label}
              onClick={() => {
                toast.action!.onClick();
                dismiss(toast.id);
              }}
            >
              {toast.action.label}
            </ToastAction>
          )}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </RadixToastProvider>
  );
}
